import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { colors } from '../../common';

class FieldTextAreaControl extends Component {
	constructor(props) {
		super(props);
		this.state = {
			characters: 0,
		};
	}

	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, prevState, snapshot) {
		const { maxLength, input } = this.props;
		// console.log('FieldTextAreaControl componentDidUpdate', input);
		const inputValue = this.getValueFromInputEvent(input?.value);
		const prevInputValue = this.getValueFromInputEvent(prevProps?.input?.value);
		if (maxLength !== prevProps.maxLength || inputValue?.length !== prevInputValue?.length) {
			if (maxLength) {
				const maxCharacters = parseInt(maxLength, 6);
				let length = 0;

				if (input && inputValue) {
					length = inputValue.length;
				}

				this.setState({
					characters: maxCharacters - length,
				});
			}
		}
	}

	getValueFromInputEvent = (e) => {
		if (e?.nativeEvent) {
			return e.target.value;
		}
		return e?.value;
	};

	handleChange = (e) => {
		const { input } = this.props;
		const value = this.getValueFromInputEvent(e);
		// console.log('FieldTextAreaControl handleChange', value);
		input.onChange(value);
	};

	render() {
		const {
			placeholder,
			input,
			meta,
			label,
			help,
			className,
			maxLength,
			rows,
			classes,
			helperClassName,
		} = this.props;
		const { characters } = this.state;

		let divClass = meta.touched && meta.error ? 'form-group has-error' : 'form-group';
		divClass += help ? ' has-help' : '';

		let labelClass = '';
		if (className) {
			labelClass += ` ${className}`;
		}

		let helperLabelClass = 'help-block';
		if (helperClassName) {
			helperLabelClass += ` ${helperClassName}`;
		}

		let counter = '';
		if (maxLength) {
			counter = <span className="counter">{`${characters} characters left`}</span>;
		}
		return (
			<div
				id={`id_${input.name}`}
				className={`${divClass} flex-container ${classes.formRoot}`}
				style={{ height: 'inherit' }}
			>
				<FormLabel className={`${classes.label} ${labelClass}`}>
					{label}
					{counter}
				</FormLabel>

				<textarea
					name={`name_${input.name}`}
					rows={rows}
					maxLength={maxLength}
					placeholder={placeholder}
					className={`${classes.textInputStyle} text-field`}
					value={input.value}
					onChange={this.handleChange}
					onFocus={input.onFocus}
					onBlur={input.onBlur}
				/>
				{help && <span className={helperLabelClass}>{help}</span>}
				{meta.touched &&
					((meta.error && (
						<span className="error-msg">
							<i className="fa fa-times-circle" />
							&nbsp;
							{meta.error}
						</span>
					)) ||
						(meta.warning && <span className="warning-msg">{meta.warning}</span>))}
			</div>
		);
	}
}

const styles = () => ({
	label: {
		fontSize: 13,
		transform: 'none',
		paddingBottom: 4,
	},
	textInputStyle: {
		// border: 'none',
		color: colors.defaultTextColor,
		padding: '9px 10px',
		fontSize: 14,
		borderColor: 'rgba(0, 0, 0, 0.23)',
		borderRadius: 4,
		'&:hover': {
			borderColor: '#585858',
		},
		'&:focus': {
			outline: 'none',
		},
	},
	formRoot: {
		marginBottom: 25,
	},
});

FieldTextAreaControl.propTypes = {
	input: PropTypes.object.isRequired,
	placeholder: PropTypes.string,
	className: PropTypes.string,
	help: PropTypes.object,
	meta: PropTypes.object,
	maxLength: PropTypes.number,
	rows: PropTypes.number,
	label: PropTypes.string,
	classes: PropTypes.object,
	helperClassName: PropTypes.string,
};

export default withStyles(styles)(FieldTextAreaControl);
